/** 文档根路径 */
export const docsBase = '/'
